import React from "react";
import { Row, Col, Avatar, Tag, Space, Typography, Button, theme } from "antd";
import { CloseOutlined, MailOutlined } from "@ant-design/icons";
import { ApplicationUserStatus } from "../../../Common/CommonComponent";

const { Text } = Typography;

interface EditUserHeaderProps {
  userData: any;
  onClose: () => void;
}

export const EditUserHeader: React.FC<EditUserHeaderProps> = ({ userData, onClose }) => {
  const { token } = theme.useToken();
  const userInitials = `${userData?.name?.first?.[0] || ""}${userData?.name?.last?.[0] || ""}`.toUpperCase() || "AU";

  return (
    <div
      style={{
        padding: "16px 48px 16px 20px",
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        position: "relative",
      }}
    >
      <Button
        type="text"
        icon={<CloseOutlined style={{ color: token.colorIcon, fontSize: 16 }} />}
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        style={{
          position: "absolute",
          top: 14,
          right: 16,
          width: 32,
          height: 32,
          borderRadius: 16,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 10,
          cursor: "pointer",
        }}
      />

      <Row align="middle" gutter={16}>
        <Col>
          <Avatar
            size={52}
            style={{
              backgroundColor: token.colorPrimary,
              fontSize: 19,
              fontWeight: 700,
              color: token.colorTextLightSolid,
              border: `2px solid ${token.colorBorderSecondary}`,
              boxShadow: token.boxShadowSecondary,
            }}
          >
            {userInitials}
          </Avatar>
        </Col>
        <Col flex="1">
          <Space direction="vertical" size={2}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <Text style={{ color: token.colorTextHeading, fontSize: 17, fontWeight: 700, letterSpacing: "-0.01em" }}>
                {userData?.fullName || `${userData?.name?.first || ""} ${userData?.name?.last || ""}`}
              </Text>
              <Tag
                color={userData?.status === ApplicationUserStatus.Active ? "success" : "default"}
                style={{ borderRadius: 10, padding: "0 8px", fontSize: 11, fontWeight: 600, margin: 0 }}
              >
                {userData?.status === ApplicationUserStatus.Active ? "Active" : "Inactive"}
              </Tag>
            </div>
            <Text style={{ color: token.colorTextSecondary, fontSize: 12.5, display: "inline-flex", alignItems: "center", gap: 6 }}>
              <MailOutlined style={{ fontSize: 12 }} />
              {userData?.email}
            </Text>
          </Space>
        </Col>
      </Row>
    </div>
  );
};
